'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var React = require('react');
var classNames = require('classnames');
var context = require('@andes/context');
var list = require('@andes/list');
var _jsx = require('@babel/runtime/helpers/jsx');
var checkbox = require('@andes/checkbox');
var includes = require('@andes/common/build/utils/includes');
var warning = require('@andes/common/build/utils/warning');
var getListItemClassNames = require('@andes/list/build/utils/getListItemClassNames');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var includes__default = /*#__PURE__*/_interopDefaultLegacy(includes);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
var getListItemClassNames__default = /*#__PURE__*/_interopDefaultLegacy(getListItemClassNames);
const namespace = 'andes-checkbox-list';
const listNamespace = 'andes-list';
const listItemNamespace = "".concat(listNamespace, "__item");
const CHECKBOX_LIST_DISPLAY_NAME = 'CheckboxList';
const CHECKBOX_LIST_ITEM_DISPLAY_NAME = 'CheckboxListItem';
const CL_SUPPORTED_GROUP_TYPES = ['ListGroup'];
const CL_SUPPORTED_ITEM_TYPES = ['ListItem', 'CheckboxListItem'];
const WARNING_LABEL = '<CheckboxList> needs an `srLabel` prop for accessibility reasons.';
const WARNING_BUTTON_SWITCH = '<CheckboxListItem> does not allow Buttons or Switches as rightContent';
const CheckboxListItem = /*#__PURE__*/function () {
  const CheckboxListItem = /*#__PURE__*/React.forwardRef((props, ref) => {
    const {
      currentValues,
      description,
      disabled = false,
      disableSelectionComponent = false,
      id,
      leftContent,
      onClick,
      rightContent,
      rightContentPosition = 'top',
      side = 'left',
      size = 'medium',
      title,
      value,
      image: _willdeprecate$image,
      primary: _willdeprecate$primary,
      secondary: _willdeprecate$secondary,
      tertiary: _willdeprecate$tertiary,
      tertiaryPosition: _willdeprecate$tertiaryPosition
    } = props;
    const computedTitle = title || _willdeprecate$primary;
    const computedDescription = description || _willdeprecate$secondary;
    const computedRightContent = rightContent || _willdeprecate$tertiary;
    const computedLeftContent = leftContent || _willdeprecate$image;
    const computedRightContentPosition = _willdeprecate$tertiaryPosition || rightContentPosition;
    const listItemClassNames = getListItemClassNames__default["default"](_objectSpread__default["default"](_objectSpread__default["default"]({}, props), {}, {
      side,
      size,
      disabled,
      title: computedTitle,
      disableSelectionComponent,
      description: computedDescription,
      rightContent: computedRightContent,
      leftContent: computedLeftContent,
      rightContentPosition: computedRightContentPosition
    }));
    const getCheckbox = () => {
      const disableSelection = disabled || disableSelectionComponent;
      return /*#__PURE__*/_jsx__default["default"]("div", {
        className: "".concat(listItemNamespace, "-selection-control")
      }, void 0, /*#__PURE__*/_jsx__default["default"](checkbox.Checkbox, {
        checked: currentValues && includes__default["default"](currentValues, value),
        disabled: disableSelection,
        id: "".concat(id, "-selection-component-").concat(value),
        srHidden: true
      }));
    };
    const getVerifiedRightContent = () => {
      var _computedRightContent;
      if (includes__default["default"](['Button', 'Switch'], computedRightContent === null || computedRightContent === void 0 || (_computedRightContent = computedRightContent.type) === null || _computedRightContent === void 0 ? void 0 : _computedRightContent.displayName)) {
        warning__default["default"](false, WARNING_BUTTON_SWITCH);
        return undefined;
      }
      return computedRightContent;
    };
    return /*#__PURE__*/React__default["default"].createElement("li", {
      className: listItemClassNames,
      onClick: onClick,
      ref: ref
    }, side === 'left' && getCheckbox(), /*#__PURE__*/React__default["default"].createElement(list.ListItemContent, _extends__default["default"]({}, props, {
      title: computedTitle,
      description: computedDescription,
      rightContent: getVerifiedRightContent(),
      leftContent: computedLeftContent,
      rightContentPosition: computedRightContentPosition
    })), side === 'right' && getCheckbox());
  });
  CheckboxListItem.displayName = CHECKBOX_LIST_ITEM_DISPLAY_NAME;
  return CheckboxListItem;
}();
var CheckboxListItem$1 = CheckboxListItem;
const _excluded = ["children", "className", "defaultValue", "onChange", "onClick", "onSelect", "side", "value"];
const CheckboxList = /*#__PURE__*/function () {
  const CheckboxList = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
        children,
        className,
        defaultValue,
        onChange,
        onClick,
        onSelect,
        side,
        value
      } = _ref,
      listProps = _objectWithoutProperties__default["default"](_ref, _excluded);
    const componentId = context.useId(listProps.id);
    const [currentValues, setCurrentValues] = React.useState(defaultValue);
    const isUncontrolled = React.useMemo(() => value === undefined, []);
    React.useEffect(() => {
      warning__default["default"](listProps.srLabel, WARNING_LABEL);
    }, []);
    React.useEffect(() => {
      if (!isUncontrolled) {
        setCurrentValues(value);
      }
    }, [value]);
    const getValuesArray = () => Array.isArray(currentValues) ? currentValues : [];
    const customOnSelect = (event, itemProps) => {
      const {
        value: itemValue,
        disabled,
        disableSelectionComponent
      } = itemProps;
      if (disabled || disableSelectionComponent) return;
      let selectedValues = getValuesArray();
      if (includes__default["default"](selectedValues, itemValue)) {
        selectedValues = selectedValues.filter(selectedValue => selectedValue !== itemValue);
      } else {
        selectedValues.push(itemValue);
      }
      if (isUncontrolled) setCurrentValues([...selectedValues]);
      if (typeof onClick === 'function') onClick(event, itemValue);
      if (typeof onChange === 'function') onChange(event, selectedValues);
      if (typeof onSelect === 'function') onSelect(event, selectedValues);
    };
    const checkboxListClassNames = classNames__default["default"](namespace, className);
    const renderItem = child => {
      var _child$type;
      const commonProps = _objectSpread__default["default"](_objectSpread__default["default"]({}, child.props), {}, {
        addPrimaryLabel: true,
        currentValues: getValuesArray(),
        side,
        onClick: event => customOnSelect(event, child.props)
      });
      if (((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'ListItem') return /*#__PURE__*/React__default["default"].createElement(CheckboxListItem$1, commonProps);
      return /*#__PURE__*/React.cloneElement(child, _objectSpread__default["default"]({}, commonProps));
    };
    return /*#__PURE__*/React__default["default"].createElement(list.List, _extends__default["default"]({
      className: checkboxListClassNames
    }, listProps, {
      ref: ref,
      id: componentId
    }), children && React.Children.map(children, child => {
      var _child$type2, _child$type3, _child$type4, _child$type5;
      if (includes__default["default"](CL_SUPPORTED_GROUP_TYPES, child === null || child === void 0 || (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) || includes__default["default"](CL_SUPPORTED_GROUP_TYPES, child === null || child === void 0 || (_child$type3 = child.type) === null || _child$type3 === void 0 || (_child$type3 = _child$type3.wraps) === null || _child$type3 === void 0 ? void 0 : _child$type3.displayName)) {
        const enhancedItems = React.Children.map(child === null || child === void 0 ? void 0 : child.props.children, item => renderItem(item));
        return /*#__PURE__*/React.cloneElement(child, {
          children: enhancedItems
        });
      }
      if (includes__default["default"](CL_SUPPORTED_ITEM_TYPES, child === null || child === void 0 || (_child$type4 = child.type) === null || _child$type4 === void 0 ? void 0 : _child$type4.displayName) || includes__default["default"](CL_SUPPORTED_ITEM_TYPES, child === null || child === void 0 || (_child$type5 = child.type) === null || _child$type5 === void 0 || (_child$type5 = _child$type5.wraps) === null || _child$type5 === void 0 ? void 0 : _child$type5.displayName)) {
        return renderItem(child);
      }
    }));
  });
  CheckboxList.displayName = CHECKBOX_LIST_DISPLAY_NAME;
  return CheckboxList;
}();
var CheckboxList$1 = CheckboxList;
exports.CheckboxList = CheckboxList$1;
exports.CheckboxListItem = CheckboxListItem$1;
exports["default"] = CheckboxList$1;
